import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface IModalContainerProps {
  onClose: () => void;
  isOpen: boolean;
  children: ReactNode;
  padding?: Record<string, string>;
  closeIconPosition?: Record<string, number>;
}

export const ModalContainer: React.FC<IModalContainerProps> = ({
  onClose,
  isOpen,
  children,
  padding,
  closeIconPosition,
}) => (
  <Modal onClose={onClose} open={isOpen} closeAfterTransition>
    <Box
      sx={{
        maxWidth: '513px',
        position: 'relative',
        padding: padding ?? {
          lg: '62px 40px 55px',
          md: '72px 24px 40px',
          sm: '72px 24px 40px',
          xs: '72px 24px 40px',
        },
        boxSizing: 'border-box',
        backgroundColor: (theme) => theme.palette.primary.contrastText,
        borderRadius: { lg: '12px', md: '8px', sm: '8px', xs: '8px' },
        width: {
          lg: '100%',
          md: 'calc(100% - 44px)',
          sm: 'calc(100% - 44px)',
          xs: 'calc(100% - 44px)',
        },
      }}
    >
      {children}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: closeIconPosition ?? { lg: 12, md: 16, sm: 16, xs: 16 },
          right: closeIconPosition ?? { lg: 12, md: 16, sm: 16, xs: 16 },
        }}
      >
        <CloseIcon sx={{ fontSize: { lg: '32px', md: '24px', sm: '24px', xs: '24px' } }} />
      </IconButton>
    </Box>
  </Modal>
);
